import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cae517ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_loading_screen = _resolveComponent("m-loading-screen")!

  return (_openBlock(), _createElementBlock("button", _mergeProps({
    class: ["manifold m-button", [_ctx.appearanceClasses, _ctx.buttonClass]],
    disabled: _ctx.disabled
  }, _toHandlers(_ctx.$attrs)), [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_m_loading_screen, { key: 0 }))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
  ], 16, _hoisted_1))
}